export const SET_DASHBOARD_SCHEMA = 'SET_DASHBOARD_SCHEMA'
export const SET_DASHBOARD_QUERY = 'SET_DASHBOARD_QUERY'
